import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PasswordModal from './PasswordModal';
import { isSessionAuthorizedForRoute, getRequiredRoleForRoute } from '../config/auth';

/**
 * ProtectedRoute — Guardia di rotta basata su ruoli sessionStorage.
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const [isAuthorized, setIsAuthorized] = useState(() => isSessionAuthorizedForRoute(currentPath));
  const [showModal, setShowModal] = useState(!isAuthorized);

  useEffect(() => {
    const authStatus = isSessionAuthorizedForRoute(currentPath);
    setIsAuthorized(authStatus);
    setShowModal(!authStatus);
  }, [currentPath]);

  const handleAuthSuccess = () => {
    setIsAuthorized(true);
    setShowModal(false);
  };

  if (isAuthorized) {
    return children;
  }

  const requiredRole = getRequiredRoleForRoute(currentPath);
  const isAdmin = requiredRole === 'admin';

  return (
    <>
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="text-center text-gray-400 p-8 max-w-sm">
          <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 font-bold text-xl">
            🔒
          </div>
          <p className="text-lg font-bold text-gray-700">
            {isAdmin ? 'Area Riservata Amministrazione' : 'Area Riservata Personale'}
          </p>
          <p className="text-sm mt-1 text-gray-500">
            Inserisci la password autorizzata per accedere a questa sezione
          </p>
        </div>
      </div>

      {showModal && (
        <PasswordModal
          targetRoute={currentPath}
          onSuccess={handleAuthSuccess}
          onClose={() => {
            window.location.hash = '/menu';
          }}
        />
      )}
    </>
  );
};

export default ProtectedRoute;
